import { Person } from "../action-co";
import { QueovalBase } from "../global";

export class AvatarSearchModel extends QueovalBase {

  public ListCollabo: Array<Person>;

  constructor() {
    super();
    this.ListCollabo = new Array<Person>();;
  };
}
